import React from 'react'
import { Form, Icon } from 'semantic-ui-react'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { accounting } from 'accounting'

export default function CurrencyInput(props) {
  const {
    prefix,
    suffix,
    includeThousandsSeparator,
    thousandsSeparatorSymbol,
    allowDecimal,
    decimalSymbol,
    decimalLimit,
    allowNegative,
  } = props

  const mask = createNumberMask({
    prefix,
    suffix,
    includeThousandsSeparator,
    thousandsSeparatorSymbol,
    allowDecimal,
    decimalSymbol,
    decimalLimit,
    allowNegative,
  })

  let inputClassName = 'ui input'

  if (props.transparent) inputClassName += ' transparent'
  if (props.loading) inputClassName += 'loading icon'

  return (
    <Form.Field error={props.error}>
      <label>{props.label}</label>
      <div className={inputClassName}>
        <MaskedInput
          style={{ textAlign: props.textAlign }}
          mask={mask}
          placeholder={props.placeholder || props.label}
          disabled={props.disabled}
          value={props.value}
          onChange={e => {
            const value = e.target.value

            if (value && value.length > 0 && value.substr(-1) === '.')
              props.onChange(e.target.value)
            else props.onChange(accounting.unformat(e.target.value))
          }}
        />

        {props.loading && <Icon name='spinner' />}
      </div>
    </Form.Field>
  )
}

CurrencyInput.defaultProps = {
  label: null,
  placeholder: null,
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  value: '',
  onChange: () => { },
  prefix: 'Q ',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 3,
  allowNegative: false,
  textAlign: 'left',
}
